// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".L1HO1w9yLNAtSm4DsaAJ {\n  display: block;\n  margin-top: 24px;\n}\n.yaL7IqkevW0_C0DnwjBl {\n  margin-top: 8px;\n}\n.AuLMJBMHwO7081VNUmKw {\n  margin-bottom: 0;\n}\n", "",{"version":3,"sources":["webpack://./../../common/components/editors/searchUrl/update/update.module.less"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,gBAAA;AACD;AAEA;EACC,eAAA;AAAD;AAGA;EACC,gBAAA;AADD","sourcesContent":[".descriptionWrapper {\n\tdisplay: block;\n\tmargin-top: 24px;\n}\n\n.toggleWrapper {\n\tmargin-top: 8px;\n}\n\n.searchBarWrapper {\n\tmargin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptionWrapper": "L1HO1w9yLNAtSm4DsaAJ",
	"toggleWrapper": "yaL7IqkevW0_C0DnwjBl",
	"searchBarWrapper": "AuLMJBMHwO7081VNUmKw"
};
export default ___CSS_LOADER_EXPORT___;
